import { ChangeEvent, ReactElement } from 'react';
import { useField, useFormikContext } from 'formik';
import get from 'lodash/get';
import { Box } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

// Types
interface IProps {
  formikKey: string;
  name: string;
  value: boolean;
  label?: string;
}

export const FormikBooleanRadioField = ({ formikKey, value, label, ...rest }: IProps): ReactElement => {
  const [field] = useField(rest);
  const { setFieldValue, values } = useFormikContext();
  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setFieldValue(formikKey, e.target.value === 'Yes');
  };
  const formikValue: boolean = get(values, formikKey);

  return (
    <Box sx={{ display: 'flex' }}>
      <label key={formikKey} className="form-input-radio">
        <input
          {...field}
          checked={value === formikValue}
          id={`${formikKey}.${field.name}`}
          name={formikKey}
          onChange={onChange}
          type="radio"
          value={field.name}
          title={label || field.name}
        />
        <span className="checkmark" />
        <span style={visuallyHidden}>{label || field.name}</span>
      </label>
      <div className="label-text-container">
        <div className="label-text">{label || field.name}</div>
      </div>
    </Box>
  );
};
